import gql from "graphql-tag";

export const UPDATE_DEVICE_MUTATION = gql`
  mutation UpdateDevice($id: String!, $params: UpdateDeviceParams!) {
    updateDevice(id: $id, params: $params) {
      id
    }
  }
`;
